export default {"src":"/_next/static/media/bera.c2fab6c4.svg","height":64,"width":64};